// extracted by mini-css-extract-plugin
export default {"container":"G3-z"};